import React from "react";

export const OpenItemsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M13.9993 11.9827H13.9787L13.2133 6.31867C13.0467 4.98667 11.9087 3.98267 10.5673 3.98267H5.432C4.09 3.98267 2.95267 4.98667 2.78667 6.312L2.02067 11.9827H2C0.897333 11.9827 0 12.88 0 13.9827V15.9827H16V13.9827C16 12.88 15.102 11.9827 13.9993 11.9827ZM4.10867 6.484C4.192 5.818 4.76133 5.316 5.432 5.316H10.5673C11.238 5.316 11.8073 5.818 11.8913 6.49067L12.6333 11.9827H3.366L4.10867 6.484ZM14.666 14.6493H1.33267V13.9827C1.33267 13.6153 1.632 13.316 1.99933 13.316H13.9993C14.3667 13.316 14.666 13.6153 14.666 13.9827V14.6493ZM5.43133 6.64933H7.99933V7.98267H6.59667L6.41667 9.316H5.07133L5.43133 6.64933ZM2.09 4.194L0.258667 2.44067L1.18133 1.478L3.01267 3.232L2.09 4.194ZM4.30133 2.73267L3.94267 0.204667L5.26333 0.017334L5.622 2.54533L4.30133 2.73267ZM11.6967 2.73267L10.3767 2.54533L10.7353 0.017334L12.0553 0.204667L11.6967 2.73267ZM13.908 4.194L12.9853 3.23133L14.8167 1.47733L15.7393 2.44L13.908 4.194Z"
      fill="#706A85"
    />
  </svg>
);
